export * from 'react-bootstrap-original';

import PatchedOverlayTrigger from './overlay_trigger';
export const OverlayTrigger = PatchedOverlayTrigger;
